
















































































import {
  computed,
  defineComponent,
  PropType,
  onMounted,
  ref,
} from "@vue/composition-api";
import BaseButton from "@/components/BaseButton.vue";
import { areaWithUnit } from "@/utils/business";
import { swipe } from "@/utils/swipe";
import { PlantingBigType } from "@/constants/plantingType";

export type ButtonOption = {
  text: string;
  type?: string;
  size?: string;
  iconName?: string;
  onClick?: () => void;
};

export type InfoOption<T = Record<string, unknown>> = T & {
  id: number;

  soilArea?: number;
  soilAreaType?: number;
  statusText?: string;
  address?: string;
  reason?: string;
  subTitle?: string;

  // 左侧图标类型
  avatarType?: PlantingBigType;

  // 是否显示种养殖列表
  showPlantingList?: boolean;
  // 种养殖列表
  plantingList?: string[];

  // 显示病虫害防治按钮
  showPestsAndDiseasesButton?: boolean;
  // 病虫害防治按钮点击
  onPestsAndDiseasesClick?: () => void;

  buttonList?: ButtonOption[];
};

/**
 * 地块卡片
 */
export default defineComponent({
  name: "LandCard",
  props: {
    info: {
      type: Object as PropType<InfoOption>,
      default: () => ({}),
    },
    needSwipe: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const containerRef = ref<HTMLDivElement | null>(null);

    onMounted(() => {
      if (props.needSwipe && containerRef.value) {
        swipe(containerRef.value, {
          onSwipeUp: () => {
            emit("swipeup");
          },
        });
      }
    });

    return {
      containerRef,
      handleClick: () => {
        emit("click");
      },
      areaText: computed(() => {
        return areaWithUnit({
          area: props.info.soilArea,
          unitType: props.info.soilAreaType,
        });
      }),
      avatarIconName: computed(() => {
        let iconName = "";
        switch (props.info.avatarType) {
          case PlantingBigType.CropFarming:
            iconName = "icon-zhiwulei";
            break;
          case PlantingBigType.AnimalHusbandry:
            iconName = "icon-yangzhilei";
            break;
          case PlantingBigType.AquaticProducts:
            iconName = "icon-shuichanlei";
            break;
        }
        return iconName;
      }),
    };
  },
  components: { BaseButton },
});
